module.exports = __webpack_public_path__ + "static/ui-4-c5515f418f14d5281c8237284fc11979.png";